import { createFileRoute, useParams } from "@tanstack/react-router";
import { TaskDetailPage } from "@/components/task/TaskDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/tasks_/$id")({
  component: CrmAdminTaskDetail,
});

function CrmAdminTaskDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/tasks_/$id" });
  return (
    <TaskDetailPage
      taskId={Number(id)}
      isAdmin={true}
      isCrm={true}
      backTo="/admin/crm/tasks"
      
    />
  );
}
